import React from "react";

function TONHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Revolutionize Your Blockchain Projects with TON (The Open
                  Network)
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock the full potential of The Open Network with Xeer
                    Technology’s specialized TON blockchain development
                    services, built for speed, scalability, and a seamless user
                    experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TONHero;
